import React, { useState, useEffect } from "react";
import "../../style/Liste.css";
import { Link } from "react-router-dom";
import axios from "axios";

import AdminAjoutFournisseur from "./AdminAjoutFournisseur";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";

const API_URL = process.env.REACT_APP_API_URL;

function AdminListeMutuelles() {
  const [mutuelles, setMutuelles] = useState([]);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    function getMutuelles() {
      axios
        .get(`${API_URL}/api/Mutuelles`)
        .then((res) => res.data)
        .then((data) => {
          setMutuelles(data);
        });
    }

    getMutuelles();
  }, []);

  let lettrePrecedente = "";

  return (
    <div className="listeMain">
      <h1>Gestion des mutuelles</h1>
      <MDBBtn type="button" outline color="primary" onClick={handleShow}>
        Ajouter une mutuelle
      </MDBBtn>
      <ul>
        {mutuelles ? (
          mutuelles.map((mutuelle) => {
            if (mutuelle.nom.charAt(0).toUpperCase() !== lettrePrecedente) {
              lettrePrecedente = mutuelle.nom.charAt(0).toUpperCase();
              return (
                <div>
                  <div className="initial">{lettrePrecedente}</div>
                  <ul className="firstAfterInitial">
                    <li key={mutuelle.id}>
                      <Link to={`/mutuelles-admin/${mutuelle.id}`}>
                        {mutuelle.nom}
                      </Link>
                    </li>
                  </ul>
                </div>
              );
            } else {
              return (
                <div>
                  <ul>
                    <li key={mutuelle.id}>
                      <Link to={`/mutuelles-admin/${mutuelle.id}`}>
                        {mutuelle.nom}
                      </Link>
                    </li>
                  </ul>
                </div>
              );
            }
          })
        ) : (
          <li>Loading</li>
        )}
      </ul>
      <MDBContainer>
        <MDBModal isOpen={show} toggle={handleClose}>
          <MDBModalHeader>Créer une mutuelle </MDBModalHeader>
          <MDBModalBody>
            <AdminAjoutFournisseur category="mutuelles" />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type="button" outline color="primary" onClick={handleClose}>
              Fermer
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default AdminListeMutuelles;
